import { useDataSelectionContext } from "../DataSelectionContext";
import DataSelectionModel from "../DataSelectionModal";
import { useMemo } from "react";
import * as yup from "yup";
import { Form } from "react-bootstrap";
import { WfsGetFeatureRequest } from "../../../types/Wfs/WfsGetFeatureRequest";

export interface InrixVolumeProps {
  boundaryId?: string;
}

interface InrixVolumesFormValues {
  outputFormat: string;
}

export const InrixVolumes = () => {
  const layerName = "Inrix:Volumes";
  const { layers, getLayer, wfsOrder } = useDataSelectionContext();
  const layer = useMemo(() => getLayer(layerName), [layers]);

  const initialValues = useMemo(() => ({
    outputFormat: "parquet",
  } as InrixVolumesFormValues), [layer]);

  const schema = useMemo(() =>
    yup.object({
      outputFormat: yup
        .string()
        .oneOf(["parquet", "csv"])
        .required(),
    })
  , [layer]);

  const onSubmit = (values: InrixVolumesFormValues) => {
    wfsOrder({
      service: "WFS",
      version: "2.0.0",
      request: "GetFeature",
      resultType: "Results",
      typeNames: layerName,
      outputFormat: values.outputFormat,
      filter: null,
    } as WfsGetFeatureRequest);
  };

  return (
    <>
      <DataSelectionModel
        headerText="Inrix Volumes"
        initialValues={initialValues}
        validationSchema={schema}
        layer={layer}
        onSubmit={onSubmit}>
        {({ values, handleChange, handleBlur }) => (
          <>
            <Form.Group style={{ width: 300 }}>
              <Form.Label htmlFor="outputFormat">Format</Form.Label>
              <Form.Select
                id="outputFormat"
                name="outputFormat"
                value={values.outputFormat}
                onChange={handleChange}
                onBlur={handleBlur}>
                <option value="parquet">Parquet</option>
                <option value="csv">CSV</option>
              </Form.Select>
            </Form.Group>
          </>
        )}
      </DataSelectionModel>
    </>
  );
};